import React from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { clsx } from 'clsx';

'use strict';

function RundedrehenMapListItemPlace ({item}) {
  // const { trackEvent } = useMatomo();

  return <div className={clsx(`flex
    space-x-3 md:space-x-4
    overflow-hidden
    grow
    map-list-item-inner`
  , {
    'items-start': item.description,
    'items-center': !item.description,
  })}>
    {/* <div className={clsx(`
      w-10 h-10 md:w-11 md:h-11
      flex-grow-0 flex-shrink-0
    `, {
      '_dark:invert': item.logo_default,
      '_dark:grayscale': item.logo_default,
    })}>
      <img
        src={item.logo_url}
        width="40" height="40"
        loading="lazy"
        alt={item.logo_alt}
        className="block w-100 h-auto"
      />
    </div> */}

    <div className="
      min-w-0
      relative
    ">
      <p className="
        font-bold md:text-md
        text-white
      ">
        {item.url && <a
          href={item.url}
          target="_blank"
          rel="nofollow"
          // onClick={(e) => {
          //   trackEvent({ category: 'places', action: 'click outbound link', name: item.type + ' ' + item.category + ' ' + item.label, value: item.id });
          // }}
        className="
          block
          text-base md:text-md
          link-bigtarget
        ">
          {item.label}
        </a>}

        {!item.url && <span
        className="
          block
          text-base md:text-md
          text-white
        ">
          {item.label}
        </span>}
      </p>

      {item.description && <p className="
        text-sm md:text-tiny tracking-wide
        text-white
        nowrap overflow-hidden text-ellipsis
        mt-0.5
      " title={item.description}>
        {item.description}
      </p>}
    </div>
  </div>
}

export default RundedrehenMapListItemPlace;
